import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fe13b4d4")

_pushScopeId("data-v-fe13b4d4")
const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = { class: "flex w-9/12 gap-x-4" }
const _hoisted_3 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Tipe Client ", -1)
const _hoisted_5 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Status Harga ", -1)
const _hoisted_7 = { class: "px-1 py-3 border-b border-gray-lp-400" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-2" }, " Status Client ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_Select = _resolveComponent("Select")!
  const _component_advanced_filter = _resolveComponent("advanced-filter")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_freeze_unfreeze_popup = _resolveComponent("freeze-unfreeze-popup")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", {
        class: "fixed right-0 h-full z-20",
        style: 
        `background-color:rgba(0,0,0,0.3); top: 12.6rem; width: calc(100% - ${
          _ctx.isAdvancedFilterOpened && _ctx.isCollapseSidebar ? `60px` : `264px`
        });`
      
      }, null, 4), [
        [_vShow, _ctx.isAdvancedFilterOpened]
      ]),
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_Search, {
              class: "w-4/12",
              onInput: _ctx.onSearch,
              onClear: _ctx.clearSearch,
              value: _ctx.searchValue,
              placeholder: "Cari nama client"
            }, null, 8, ["onInput", "onClear", "value"]),
            _createVNode(_component_advanced_filter, {
              "model-value": _ctx.advancedFilterData,
              isScroll: false,
              addSumFilter: _ctx.countFilter,
              onChange: _ctx.onChangeAdvancedFilter,
              onOpened: _ctx.onOpenedAdvancedFilter,
              onReset: _ctx.onResetAdvancedFilter,
              class: "client"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_Select, {
                    dataSelect: _ctx.typeData,
                    onOpenSelect: _ctx.onOpenTypeSelect,
                    onCloseSelect: _ctx.onCloseTypeSelect,
                    onChooseSelect: _ctx.onSelectType,
                    value: _ctx.typeName,
                    isOpenMenu: _ctx.typeSelect,
                    class: "w-full"
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                ]),
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_Select, {
                    dataSelect: _ctx.statusRates,
                    onOpenSelect: _ctx.onOpenStatusSelect,
                    onCloseSelect: _ctx.onCloseStatusSelect,
                    onChooseSelect: _ctx.onSelectStatus,
                    value: _ctx.statusName,
                    isOpenMenu: _ctx.statusSelect,
                    class: "w-full"
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                ]),
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_Select, {
                    dataSelect: _ctx.statusDataRenewal,
                    onOpenSelect: _ctx.onOpenStatusSelectRenewal,
                    onCloseSelect: _ctx.onCloseStatusSelectRenewal,
                    onChooseSelect: _ctx.onSelectStatusRenewal,
                    value: _ctx.statusNameRenewal,
                    isOpenMenu: _ctx.statusSelectRenewal,
                    class: "w-full"
                  }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
                ])
              ]),
              _: 1
            }, 8, ["model-value", "addSumFilter", "onChange", "onOpened", "onReset"])
          ])
        ]),
        _: 1
      }),
      (_ctx.isError && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_ErrorMessage, {
            key: 0,
            errorType: _ctx.errorCause,
            onTryAgain: _ctx.onRequest
          }, null, 8, ["errorType", "onTryAgain"]))
        : (_ctx.clientManagement.length === 0 && _ctx.firstRequest && !_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_EmptyState, {
              key: 1,
              data: "data Client"
            }))
          : (_openBlock(), _createBlock(_component_TableV2, {
              key: 2,
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pagination = $event)),
              loading: _ctx.isLoading,
              columns: _ctx.isActionAble ? _ctx.columns : _ctx.columns.slice(0, -1),
              data: _ctx.clientManagement,
              class: "my-2",
              onRequest: _ctx.onRequest,
              onClick: _ctx.onClickRow,
              isDetailAble: _ctx.isDetailAble,
              totalColumnFreeze: 1,
              isRightFreeze: _ctx.isActionAble,
              pinnedSubstractHeight: "290px"
            }, null, 8, ["pagination", "loading", "columns", "data", "onRequest", "onClick", "isDetailAble", "isRightFreeze"]))
    ]),
    (_ctx.freezeUnFreezeModal)
      ? (_openBlock(), _createBlock(_component_freeze_unfreeze_popup, _mergeProps({
          key: 0,
          modelValue: _ctx.freezeUnFreezeModal,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.freezeUnFreezeModal = $event))
        }, _ctx.clientSelected, { onSuccess: _ctx.onRequest }), null, 16, ["modelValue", "onSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
})